import { PlannerValidation } from '@inter-ikea-storageone/range';
import { ComponentIds } from '@inter-ikea-core/core';
export class PlatsaDoorsValidation extends PlannerValidation {
    constructor(coreApi) {
        super(coreApi, 'PlatsaDoorsValidation');
    }
    validateCurrentState() {
        return this.validationOK();
    }
    validateSnap(snapActionCandidate) {
        const entity = snapActionCandidate.guestRoot;
        const doorSize = entity.getComponent(ComponentIds.COMMUNICATION_SIZE_COMPONENT_ID);
        const frameSize = snapActionCandidate.host.getComponent(ComponentIds.COMMUNICATION_SIZE_COMPONENT_ID);
        if (doorSize && frameSize) {
            const doorWidth = doorSize.size.width;
            const frameWidth = frameSize.size.width;
            if (frameWidth === 800 && doorWidth === 600) {
                return this.validationFail(`60cm wide door is not allowed on 80cm wide frame`);
            }
            else if (frameWidth === 600 && doorWidth === 400) {
                return this.validationFail(`40cm wide door is not allowed on 60cm wide frame`);
            }
        }
        return this.validationOK();
    }
}
//# sourceMappingURL=PlatsaDoorsValidation.js.map